import React, { Component } from "react";
import axios from "axios";

import { Card, Grid, TextField, Typography } from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import { Navigate } from "react-router-dom";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class UpdateBlogs extends Component {

  state = {
    blog_id: "",
    title: "",
    meta_key: "",
    meta_description: "",
    img_alt_text: "",
    blog_content: "",

    selectedImage: null,
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    const blog_id = window.location.pathname.split("/")[2];

    this.setState({ blog_id }, () => {
      this.getBlogDetails();
    });
  }

  // ✅ GET DETAILS
  getBlogDetails = async () => {
    try {
      const resp = await axios.post(Constants.getUrls.getBlogDetails, {
        blog_id: window.location.pathname.split("/")[2],
      });

      const data = resp.data.data;
      // console.log("Blog details:", resp);
      
      this.setState({
        title: data.title || "",
        meta_key: data.meta_key || "",
        meta_description: data.meta_description || "",
        img_alt_text: data.img_alt_text || "",
        blog_content: data.blog_content || "",

        // preload image
        selectedImage: data.image_id
          ? {
              id: data.image_id,
              image_path: data.image_path, // backend should send this
            }
          : null,
      });

    } catch (error) {
      this.setState({
        notification: true,
        message: "Failed to fetch blog details",
      });
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDescription = (content) => {
    this.setState({ blog_content: content });
  };

  // ✅ UPDATE API
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      blog_id,
      title,
      meta_key,
      meta_description,
      img_alt_text,
      blog_content,
      selectedImage,
    } = this.state;

    if (!title || !blog_content) {
      return this.setState({
        notification: true,
        message: "Title and content are required",
      });
    }

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      blog_id,
      title,
      meta_key,
      meta_description,
      img_alt_text,
      blog_content,
      image_id: selectedImage.id,
    };

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(
          Constants.putUrls.updateBlog,
          payload
        );

        this.setState({
          notification: true,
          message: resp.data.message,
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2000);
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Update failed",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/blogs" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>

            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <Typography variant="h6" color="white">
                Update Blog
              </Typography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* Title */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Blog Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* IMAGE PICKER */}
                  <Grid item xs={12} md={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() =>
                        this.setState({ showMediaModal: true })
                      }
                    >
                      Change Image
                    </MDButton>

                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 100,
                          height: 100,
                          marginTop: 10,
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </Grid>

                  {/* ALT TEXT */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Image Alt Text"
                      name="img_alt_text"
                      value={this.state.img_alt_text}
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* META */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Meta Keywords"
                      name="meta_key"
                      value={this.state.meta_key}
                      onChange={this.handleInput}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Meta Description"
                      name="meta_description"
                      value={this.state.meta_description}
                      onChange={this.handleInput}
                    />
                  </Grid>

                  {/* SUNEDITOR (UNCHANGED ✅) */}
                  <Grid item xs={12}>
                    <SunEditor
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["font", "fontSize"],
                          ["paragraphStyle", "blockquote"],
                          [
                            "bold",
                            "underline",
                            "italic",
                            "strike",
                            "subscript",
                            "superscript",
                          ],
                          ["fontColor", "hiliteColor"],
                          ["align", "list", "lineHeight"],
                          ["outdent", "indent"],
                          ["table", "horizontalRule", "link", "image", "video"],
                          ["imageGallery"],
                          ["preview", "print"],
                          ["removeFormat"],
                        ],
                        defaultTag: "div",
                        height: 120,
                        showPathLabel: false,
                      }}
                      setContents={this.state.blog_content}
                      onChange={this.handleDescription}
                    />
                  </Grid>

                  {/* SUBMIT */}
                  <Grid item xs={12}>
                    <MDButton variant="contained" color="info" type="submit">
                      {this.state.loading ? "Updating..." : "Update Blog"}
                    </MDButton>
                  </Grid>

                </Grid>
              </form>
            </MDBox>

            {/* SNACKBAR */}
            <MDSnackbar
              color="success"
              title="Blogs"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* MEDIA MODAL */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />

          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}